<template>
    <rkm-overlay>
        <rkm-layout-body :title="`${id ? 'Edição' : 'Cadastro'} de paciente`">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="hasPermissaoAtualizacaoCadastroPaciente && !!id && !readonly"
                    @click="handleBuscarDadosPacienteIntegracaoCns"
                    color="info"
                >
                    Buscar dados do paciente no CADSUS
                </rkm-button>

                <rkm-button
                    v-if="id"
                    @click="$refs.Form.print()"
                    color="info"
                >
                    Imprimir
                </rkm-button>

                <rkm-button
                    v-if="id && !readonly"
                    @click="$refs.Form.historico()"
                >
                    Histórico de atualização
                </rkm-button>

                <rkm-button
                    v-if="id && !readonly"
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <template
                v-if="paciente && paciente.cidadao && paciente.cidadao.nome"
                v-slot:subtitle
            >
                <div class="sub-title">
                    <rkm-icon class="icon" icon="user"/>
                    <span class="text-uppercase" v-if="paciente.cidadao.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        {{ paciente.cidadao.nome }} <strong>({{ paciente.cidadao.nomeSocial }})</strong>,
                    </span>
                    <span class="text-uppercase" v-else>
                        {{ paciente.cidadao.nome }}
                    </span>
                </div>
            </template>

            <rkm-layout-content :noCardStyle="!!id">
                <Form
                    :id="id"
                    @loaded="loaded"
                    @paciente="handlePaciente"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>

            <ModalIntegracaoCns
                @update="handleIntegracaoCnsUpdate"
                ref="ModalIntegracaoCns"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/cadastro/paciente/Form'
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'

// Mixins.
import {unmask} from '@/mixins'

// Others.
import moment from 'moment'

// Enums
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        Form,
        ModalIntegracaoCns,
    },
    computed: {
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.cidadao && this.cidadao.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.cidadao && this.cidadao.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.cidadao && this.cidadao.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
        readonly() {
            return this.$route.path.includes('/show/')
        },
    },
    data: () => ({
        additionals: null,
        cidadao: null,
        enums: {classificacao, preferenciaNome},
        others: {moment},
        paciente: null,
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        loaded(value) {
            this.additionals = value.additionals
            this.cidadao = value.cidadao
        },
        handleExit() {
            if (this.readonly) {
                this.unsetShowExitFormConfirmation()
                this.redirectToList()
            } else {
                this.showExitConfirmation(async () => {

                    this.unsetShowExitFormConfirmation()
                    this.redirectToList()
                })
            }
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {
            this.$router.push({ name: 'cadastro-paciente-index' })
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.cidadao.id,
                nome: this.cidadao.nome,
                dataNascimento: this.cidadao.dataNascimento,
                nomeMae: this.cidadao.nomeMae,
                cns: this.cidadao.cns ? this.unMaskCns(this.cidadao.cns) : null,
                cpf: this.cidadao.cpf ? this.unMaskCpf(this.cidadao.cpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate() {
            this.$router.go()
        },
        handlePaciente(paciente) {

            this.paciente = paciente
        }
    },
    mixins: [unmask],
    props: {
        id: { type: Number, default: null }
    },
    created() {

        this.setShowExitFormConfirmation()
    }
}
</script>

<style scoped>
.sub-title {
    font-size: 13px;
    text-transform: uppercase;
    color: #222;
}
</style>